import { putRequest } from "utils/request";

export const forgotPasswordRequest = (email) => {
  const url = "v1/users/forgot-password/";

  return putRequest(url, { email });
};
